<template>
    <div>
        <component :chartdata="chartdata" :options="options" :is="type"></component>
    </div>
</template>
<script>
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels';
import Pie from './Pie';
import Bar from  './Bar';
import Line from './Line';
import Donut from './Donut';
import HorizontalBar from './horizontal';
Chart.defaults.global.plugins.datalabels.display = false;
export default {
    
    props:['chartdata', 'options', 'type'],
    components: {
        'pie': Pie,
        'bar' :Bar,
        'line-graph' : Line,
        'donut' : Donut,
        'horizontal' : HorizontalBar,
    }
}
</script>

